<template>
	<div style="display: flex;">
		<div style="width: 200px;height: 300px;background-color: red;"></div>
		<div
		  class="scale-box"
		  :style="{
		    transform: `scale(${scale}) translate(-50%, -50%)`,
		    WebkitTransform: `scale(${scale}) translate(-50%, -50%)`,
		    width: width + 'px',
		    height: height + 'px',
		  }"
		>
		  <H1 class="mt-60px">测试</H1>
		</div>
		<div style="width: 200px;height: 300px;background-color: yellow;"></div>
	</div>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      scale: this.getScale(),
      timer: null, // 用于存储定时器 ID
    }
  },
  mounted() {
    window.addEventListener('resize', this.setScale)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setScale)
  },
  methods: {
    getScale() {
      let ww = window.innerWidth / this.width
      let wh = window.innerHeight / this.height
      return ww < wh ? ww : wh
    },
    debounce(func, delay) {
      return (...args) => {
        if (this.timer) clearTimeout(this.timer) // 清除上一次的定时器
        this.timer = setTimeout(() => {
          func(...args)
        }, delay)
      }
    },
    setScale() {
      this.debounce(() => {
        this.scale = this.getScale()
      }, 500)()
    }
  },
}
</script>

<style scoped>
.scale-box {
  position: relative;
  top: 50%;
  left: 40%;
  transform-origin: top left;
}
</style>
